import React from 'react';
import { Link } from 'react-router-dom';
import './HelpPage.css';

const faqs = [
  {
    q: 'How do I invite my spouse or a family member?',
    a: 'After you create your vault, go to the Profiles tab and click "Invite Member." Enter their email address and they\'ll receive an invitation link. When they click it and create their own account, they\'ll be added to your vault automatically.',
  },
  {
    q: 'Where do I upload my important documents?',
    a: 'From your vault, click the "Documents" tab. Use the upload area or tap the "+" button to attach files from your phone or computer — PDFs, photos of documents, or anything else you want to preserve.',
  },
  {
    q: 'How do I record my funeral and service wishes?',
    a: 'Click the "Funeral Plans" tab in your vault. You can describe your service preferences, burial wishes, music selections, and any other instructions you\'d like your family to have.',
  },
  {
    q: 'What if I lose my phone and can\'t log in?',
    a: 'Email us at support@cedarvaultapp.com. We\'ll verify your identity and reset your two-factor authentication so you can sign in again. You\'ll then be able to set up your new phone from the start — no information is ever lost.',
  },
  {
    q: 'Is my information safe?',
    a: 'Yes. Everything in your vault is encrypted, stored on U.S.-based servers, and protected by two-factor authentication. We treat your family\'s most personal information the way we treat our own.',
  },
  {
    q: 'Who can see what\'s in my vault?',
    a: 'Only the people you personally invite. You control who has access. Cedar Vault staff can see your account information (like your email address) but never the contents of your vault.',
  },
  {
    q: 'How do I change my password?',
    a: 'Once signed in, click "Change Password" in the navigation bar at the top. You can also use "Forgot password?" on the sign-in page at any time — we\'ll send a reset link to your email.',
  },
  {
    q: 'I\'m having trouble — how do I get help?',
    a: 'Email us at support@cedarvaultapp.com anytime. We\'re a small, family-owned team and we\'ll respond personally. There\'s no call center, no bots — just real people who care about helping your family.',
  },
];

export default function HelpPage() {
  return (
    <div className="help-page">
      <header className="help-header">
        <Link to="/login" className="help-brand">
          <svg className="help-logo" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="32" height="32" rx="6" fill="#1a1a2e"/>
            <path d="M16 3 L5 7.5 L5 18 C5 24.5 10 29 16 31 C22 29 27 24.5 27 18 L27 7.5 Z" fill="#a0785a"/>
            <polygon points="16,9 11.5,14 13.5,14 10,19.5 13.5,19.5 13.5,23 18.5,23 18.5,19.5 22,19.5 18.5,14 20.5,14" fill="#f8f7f4"/>
          </svg>
          Cedar Vault
        </Link>
      </header>

      <main className="help-content">
        <p className="help-eyebrow">Help Center</p>
        <h1 className="help-title">How can we help?</h1>
        <p className="help-intro">
          Simple answers to the questions we hear most often.
          If you don't see what you're looking for, just email us — we're happy to help.
        </p>

        <div className="help-faq-list">
          {faqs.map((item, i) => (
            <div className="help-faq-card" key={i}>
              <h2 className="help-faq-q">{item.q}</h2>
              <p className="help-faq-a">{item.a}</p>
            </div>
          ))}
        </div>

        <div className="help-contact">
          <p>Still have a question?</p>
          <a href="mailto:support@cedarvaultapp.com" className="help-contact-link">
            support@cedarvaultapp.com
          </a>
          <div className="help-nav-links">
            <Link to="/login">Sign In</Link>
            <span className="help-sep">&middot;</span>
            <a href="https://cedarvaultapp.com" target="_blank" rel="noopener noreferrer">
              About Cedar Vault
            </a>
            <span className="help-sep">&middot;</span>
            <a href="https://cedarvaultapp.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
